<script setup lang="ts">
import { copyToClipboard } from '@/utils/apostatudo/clipboard';

const props = defineProps<{
  deposit: DefaultDepositInfoResponse;
}>();

const emit = defineEmits(['toggleModalInner']);

const { closeModal } = useLayoutStore();
const { updateWallet } = useWallet();

function closePaymentInfos() {
  emit('toggleModalInner');
}

const inputCodeElement = ref();

const isClabeCodeCopied = ref<boolean>(false);

const handdleCopyCode = async () => {
  const codeToCopy = props.deposit.clabe || 'Fail';

  try {
    inputCodeElement.value?.select?.();
  } catch {}

  if (await copyToClipboard(codeToCopy)) {
    isClabeCodeCopied.value = true;
    setTimeout(() => (isClabeCodeCopied.value = false), 2000);
  }
};

const handdleSpeiPayed = () => {
  closeModal();
  updateWallet();
};

onUnmounted(() => {
  if (localStorage.getItem('start_countdown')) {
    localStorage.removeItem('start_countdown');
  }

  if (localStorage.getItem('init_countdown')) {
    localStorage.removeItem('init_countdown');
  }
});
</script>

<template>
  <div
    ref="deposit-payment"
    class="deposit-payment"
  >
    <button
      class="scan-title"
      @click="closePaymentInfos()"
    >
      &#8592; {{ $t('deposit.general.go_back') }}
    </button>

    <div class="text-center mt-3 mb-5">
      <h5 class="scan-title">
        {{ $t('deposit.spei.copy_code') }}
      </h5>

      <div
        class="clickToCopy"
        @click="handdleCopyCode"
      >
        <div class="handIcon">
          <NuxtIcon name="hand_pointer" />
        </div>
        <div class="my-3">
          <p
            ref="input"
            class="depositValue"
          >
            {{ props.deposit.amount }}
          </p>
        </div>

        <div class="inputCode">
          <input
            ref="inputCodeElement"
            class="input-center small"
            readonly
            type="text"
            :value="props.deposit.clabe"
          />
        </div>

        <div>
          <button
            :class="['buttonsBottom', appNameLower()]"
            size="lg"
            variant="secondary"
          >
            <NuxtIcon
              v-if="isClabeCodeCopied"
              name="check"
            />
            {{
              isClabeCodeCopied
                ? $t('deposit.spei.code_copied')
                : $t('deposit.spei.copy_code_button')
            }}
          </button>
        </div>
      </div>

      <div class="timer mt-5 mb-0">
        <WidgetsCountdown
          class="text-xs"
          :progress-bar="true"
          :total-time="600"
        >
          <template #process="{ time }">
            <div class="timer_wrapper flex flex-row items-end justify-between">
              <span class="bonus-countdown-expire text-warning font-bold">
                {{ $t('deposit.spei.time_to_pay') }}
              </span>
              <span class="bonus-countdown-time text-texts font-bold text-sm">
                {{ `${time.minutes}:${time.seconds}` }}
              </span>
            </div>
          </template>
          <template #finish>
            <span class="bonus-countdown-expire text-error font-bold">
              {{ $t('deposit.spei.time_finished') }}
            </span>
          </template>
        </WidgetsCountdown>
      </div>

      <div class="mt-3">
        <button
          class="buttonsBottom small"
          variant="primary"
          @click="handdleSpeiPayed"
        >
          {{ $t('deposit.spei.confirm_payment') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.deposit-payment {
  .scan-title {
    @apply text-auth-texts m-1 mb-2 max-w-[280px] mx-auto;
  }
  .clickToCopy {
    @apply border-dashed border-auth-texts/60 border rounded-lg px-7 py-8 my-5 relative mx-1 md:mx-4;
    .handIcon {
      @apply absolute top-4 right-4 text-auth-texts/40 text-3xl cursor-pointer;
    }
    .depositValue {
      @apply text-primary font-bold text-3xl leading-3 -mt-1 mb-5;
    }
    .inputCode {
      @apply mb-2 md:mb-3 w-full;
      .input-center {
        @apply bg-auth-bg-inputs text-auth-text-inputs/80 text-center rounded-lg w-full px-4 h-[60px] text-lg;
      }
    }
  }
  .timer {
    @apply px-3 pb-4 my-5 relative mx-1 md:mx-4;
  }
  .buttonsBottom {
    @apply inline-flex items-center justify-center gap-2;
    @apply text-auth-button-bg bg-auth-button-bg/10;
    @apply py-2 md:py-3 px-6 rounded w-full md:w-auto;
    &.small {
      @apply text-sm py-2 px-5 mt-2 -mb-2 text-success bg-success/10 w-auto;
    }
  }
}
</style>
